import React, { Component } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import moment from 'moment'
import MacroGraph from '../components/average-graph/macro-graph'

class ComplianceDetailsModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
    if (this.props.relatedWeighInDetails !== null && this.props.relatedWeighInDetails.level === 0) {
      this.props.getMacroData(this.props.relatedWeighInDateString)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.complianceDetailsDate !== prevProps.complianceDetailsDate && this.props.relatedWeighInDetails !== null && this.props.relatedWeighInDetails.level === 0) {
      this.props.getMacroData(this.props.relatedWeighInDateString)
    }
  }

  handleClose = () => {
    this.props.handleClose();
  }

  render() {
    return (
      <Dialog className='weigh-in-dialog' open={this.props.open} onClose={this.handleClose}>
        <DialogContent className='avn-modal-content-container'>
          <div className='avn-modal-header-container'>
            {this.props.relatedWeighInDetails === null ? (
              <div>
                <h4>{moment.utc(this.props.complianceDetailsDate).format('MMM D, YYYY')}</h4>
                <p>Average tracked macros are not available for this check-in.</p>
              </div>
            ) : (this.props.relatedWeighInDetails.level !== 2 ? (
              <div>loading...</div>
            ) : (
              <div>
                <h4 style={{fontSize: '1.5rem', margin: '16px 0px'}}>{moment.utc(this.props.complianceDetailsDate).format('MMM D, YYYY')}</h4>
                <MacroGraph
                  proteinConsumed={Math.round(this.props.relatedWeighInDetails.result.avgProtein)}
                  carbsConsumed={Math.round(this.props.relatedWeighInDetails.result.avgCarbs)}
                  fatConsumed={Math.round(this.props.relatedWeighInDetails.result.avgFat)}
                  proteinTarget={Math.round(this.props.relatedWeighInDetails.result.avgTargetProtein)}
                  carbsTarget={Math.round(this.props.relatedWeighInDetails.result.avgTargetCarbs)}
                  fatTarget={Math.round(this.props.relatedWeighInDetails.result.avgTargetFat)}
                  vacationMode={this.props.vacationMode}
                  showConsumedMacros
                  showUnderRange
                  light
                />
              </div>
            ))}
          </div>
        </DialogContent>
        <DialogActions className="avn-modal-actions-container">
          <button className='avn-modal-action' onClick={this.handleClose} style={{marginTop: 0}}>Close</button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default ComplianceDetailsModal
